import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./../../assets/scss/common.scss";

const InvoicePageSkeleton = () => {
  return (
    <div className="d-flex justify-content-center align-items-start min-vh-100 p-4">
      <div className="w-100 max-width-1100">
        <div className="mb-4">
          <div className="mb-2">
            <Skeleton width="28%" height={44} />
          </div>
          <div className="d-flex align-items-center gap-3 mb-2">
            <Skeleton width={110} height={36} />
            <Skeleton width={110} height={36} />
          </div>
          <div className="margin-bt-12">
            <Skeleton width="100%" height={2} />
          </div>
          <div>
            <Skeleton width="45%" height={20} />
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive mb-3">
          <table className="table min-width-800">
            <thead>
              <tr>
                <th className="width-48">
                  <Skeleton width={20} height={20} circle />
                </th>
                <th>
                  <Skeleton width="80%" height={20} />
                </th>
                <th>
                  <Skeleton width="70%" height={20} />
                </th>
                <th>
                  <Skeleton width="60%" height={20} />
                </th>
                <th>
                  <Skeleton width="60%" height={20} />
                </th>
                <th>
                  <Skeleton width="90%" height={20} />
                </th>
              </tr>
            </thead>

            <tbody>
              {[1, 2].map((r) => (
                <tr key={r}>
                  {/* checkbox */}
                  <td>
                    <Skeleton width={20} height={20} circle />
                  </td>

                  {/* invoice number */}
                  <td>
                    <Skeleton width="65%" height={18} />
                  </td>

                  {/* customer */}
                  <td>
                    <Skeleton width="55%" height={18} />
                  </td>

                  {/* invoice total */}
                  <td>
                    <Skeleton width="45%" height={18} />
                  </td>

                  {/* due date */}
                  <td>
                    <Skeleton width="50%" height={18} />
                  </td>

                  {/* comments textarea */}
                  <td>
                    <Skeleton
                      width="100%"
                      height={38}
                      className="borderRadius-4"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination (left) + Search (right) */}
        <div className="d-flex justify-content-between align-items-center mb-4 flex-column flex-md-row gap-3">
          <div>
            <Skeleton width={220} height={24} />
          </div>
          <div className="minWidth-200">
            <Skeleton width={180} height={34} />
          </div>
        </div>

        {/* Bottom buttons centered */}
        <div className="d-flex flex-column align-items-center gap-3 mb-5">
          <Skeleton width={240} height={48} />
          <Skeleton width={260} height={36} />
        </div>
      </div>
    </div>
  );
};

export default InvoicePageSkeleton;
